import { useMemo } from "react";

import {
  Issue,
  Issue_ScaAttributes_FixRecommendation,
} from "@protos/issues/v1/issues";

/**
 * Retrieves the SCA issue's recommended fix version (if applicable).
 */
export function useScaRecommendedDependencyUpdate(issue: Issue) {
  return useMemo(() => {
    if (issue.scaAttributes === undefined) {
      return null;
    }

    if (issue.scaAttributes.bestFix !== undefined) {
      // if a best fix was identified, use that one
      return issue.scaAttributes.bestFix;
    }

    // otherwise, choose one of the versions that matches the current package
    const issueDependencyName = issue.scaAttributes.foundDependency?.package;
    let recommendedUpdate: Issue_ScaAttributes_FixRecommendation | undefined =
      undefined;
    if (issueDependencyName !== undefined) {
      recommendedUpdate = issue.scaAttributes.fixRecommendations.findLast(
        (fixRec) => fixRec.package === issueDependencyName
      );
    }

    return recommendedUpdate;
  }, [issue.scaAttributes]);
}
